import { createContext } from 'react';
import { IBottlerAccess } from '../models';

export const BottlersAccess = createContext<{
  bottlersAccess: IBottlerAccess[];
}>({
  bottlersAccess: []
});
